import React from 'react';
import { PropTypes } from 'prop-types';
import formatDate from 'common/utils/Dates/formatDate';
import EnrollmentStatusIndicator from '../EnrollmentStatusIndicator';
import AssignUserToEnrollment from '../AssignUserToEnrollment';

const EnrollmentDetailsCardHeader = ({ enrollmentRequest, label }) => (
  <div className="flex justify-between pb-4">
    <div>
      <h1 className="pt-2 text-2xl font-semibold text-text-blue leading-8">
        {label + enrollmentRequest.short_id}
      </h1>
      <div className="flex pb-2 space-x-6 items-center">
        <p className="text-text-blue text-sm leading-5">Last updated: {formatDate(enrollmentRequest.updated_at)}</p>
        <EnrollmentStatusIndicator status={enrollmentRequest.enrollment_status} />
      </div>
    </div>
    <div>
      <AssignUserToEnrollment enrollmentRequest={enrollmentRequest} />
    </div>
  </div>
  );

EnrollmentDetailsCardHeader.propTypes = {
  enrollmentRequest: PropTypes.shape({
    id: PropTypes.string.isRequired,
    short_id: PropTypes.string.isRequired,
    updated_at: PropTypes.string.isRequired,
    enrollment_status: PropTypes.string.isRequired,
    assignee: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  label: PropTypes.string.isRequired,
};

export default EnrollmentDetailsCardHeader;
